var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 224.08 273.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}.cls-2{fill:#ffc99d;}.cls-10,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-9{stroke:#2a3561;stroke-miterlimit:10;stroke-width:0.5px;}.cls-10,.cls-2{stroke-linecap:round;}.cls-3{fill:#fff;}.cls-4{fill:#37a7f4;}.cls-5{fill:#6bc6df;}.cls-10,.cls-6{fill:none;}.cls-7{fill:#31f4cf;}.cls-8,.cls-9{fill:#2a3561;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ELEMENTS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "charecter"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse",
    className: "cls-1",
    cx: 112.04,
    cy: 112.61,
    rx: 112.04,
    ry: 112.61
  }), /*#__PURE__*/React.createElement("g", {
    id: "doctor_1",
    "data-name": "doctor 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    className: "cls-2",
    x: 94.08,
    y: 244.02,
    width: 12.42,
    height: 12.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    className: "cls-2",
    x: 117.68,
    y: 244.02,
    width: 12.42,
    height: 12.59
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    className: "cls-3",
    d: "M132,137.67H88V242.88a3.81,3.81,0,0,0,3.78,3.84h13.8a3.82,3.82,0,0,0,3.79-3.84v-94a2.56,2.56,0,0,1,2.55-2.58h0a2.56,2.56,0,0,1,2.55,2.58v94a3.82,3.82,0,0,0,3.79,3.84H132a3.81,3.81,0,0,0,3.78-3.84V137.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    className: "cls-4",
    d: "M94.08,253.9H91.3s.59,4.37-1.09,5.82-19.54,9.57-19.54,9.57v4.16h36.38a4.52,4.52,0,0,0,4.39-5.56l-3.1-14H106.5s-1.33,2.39-6.67,2.39S94.08,253.9,94.08,253.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    className: "cls-4",
    d: "M130.25,253.9H133s-.58,4.37,1.09,5.82,19.54,9.57,19.54,9.57v4.16H117.27a4.56,4.56,0,0,1-4.39-5.56l3.1-14h1.85s1.33,2.39,6.67,2.39S130.25,253.9,130.25,253.9Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    className: "cls-5",
    x: 91.35,
    y: 132.93,
    width: 41.61,
    height: 6.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    className: "cls-4",
    x: 90.77,
    y: 71.12,
    width: 42.8,
    height: 64.02
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    className: "cls-6",
    x1: 111.72,
    y1: 106.41,
    x2: 111.72,
    y2: 135.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    className: "cls-7",
    d: "M113.27,76.87h-1.69l-5.3,42.69,6.14,5.85,6.15-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    className: "cls-2",
    d: "M114.79,71.91h-5.61a4.65,4.65,0,0,1-4.65-4.65h0V57.86h14.91v9.39A4.66,4.66,0,0,1,114.79,71.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    className: "cls-8",
    d: "M104.9,61.87a13.7,13.7,0,0,0,7.1,4.38c4.86,1.33,7.43,0,7.43,0V61.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    className: "cls-7",
    d: "M112.42,71.12a5.82,5.82,0,0,0-4.27,1.94,13.28,13.28,0,0,0,1.29,4.27,4.68,4.68,0,0,0,3,2.57,4.67,4.67,0,0,0,3-2.57,13.28,13.28,0,0,0,1.29-4.27A5.82,5.82,0,0,0,112.42,71.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    className: "cls-3",
    d: "M101.14,67.83s1.68,10.65-3.89,13.42l-5.89,95.51L88,183.24v13.19s-13.87-4-15-10.27c-.49-2.78,11.39-74.49,11.39-74.49L73.2,118.58l.31,9.73s-7,2.12-11.39-.41a9.24,9.24,0,0,1-1.9-1.5,14,14,0,0,1-2.45-16.09L82.14,75.56A11.55,11.55,0,0,1,88,71.13C91.34,69.94,101.14,67.83,101.14,67.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    className: "cls-6",
    x1: 84.99,
    y1: 101.8,
    x2: 89.99,
    y2: 80.68
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    className: "cls-4",
    d: "M68.28,111.93,59.63,94.6a2,2,0,0,1,.91-2.7,1.92,1.92,0,0,1,1.08-.2l20.92,2a4.47,4.47,0,0,1,3.65,2.64l12.44,28.36a2,2,0,0,1-1,2.64,1.92,1.92,0,0,1-.91.17l-18.78-.84a4.44,4.44,0,0,1-3.82-2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    className: "cls-9",
    d: "M98.75,38.43a4.62,4.62,0,0,0-1.23,2.3v7.19h2.84v-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    className: "cls-2",
    d: "M112,30.79c-12.86,0-11.62,7.79-11.62,7.79V54.4c0,9,11.62,9.4,11.62,9.4s11.62-.37,11.62-9.4V38.58S124.84,30.79,112,30.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    className: "cls-2",
    d: "M100.33,45.11a1.94,1.94,0,0,0-2.7.45,2,2,0,0,0-.3.66c-1,3.17,3,5.87,3,5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    className: "cls-2",
    d: "M123.63,45.11a1.92,1.92,0,0,1,2.69.45,1.82,1.82,0,0,1,.31.66c1,3.17-3,5.87-3,5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    className: "cls-2",
    d: "M73,112.8l5.72-2.61,10-4.62a5.28,5.28,0,0,1,3.54,2c1,1.69,1.32,6.28.48,7.59l-2.51,1.72a16.31,16.31,0,0,1,.56,3.4,19.5,19.5,0,0,1-4.17,2.06C82,124,80.21,124,80.21,124l-6.79,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    className: "cls-3",
    d: "M61.6,113s8.13-3.64,9.39-3.69a3.92,3.92,0,0,1,2.43,1l.21,18.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    className: "cls-9",
    d: "M100.36,40.72s-4.08-1.36-4.45-4.33,2.84-2.53,2.84-2.53a3,3,0,0,1,.31-3.28c1.3-1.45,4-.18,4.94,0s1.42-2.47,3.22-3.27,12,1.54,15.2,2.29,3.78,5.75,3.78,7.23V45a3.73,3.73,0,0,0-2.57.16V40.72A49.14,49.14,0,0,1,111,39.17c-6.52-1.85-8-4-8-4A7,7,0,0,0,100.36,40.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    className: "cls-2",
    d: "M108.58,57.41s.87.87,3.4.87,3.33-.87,3.33-.87"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    className: "cls-10",
    x1: 92.24,
    y1: 107.58,
    x2: 84.37,
    y2: 111.67
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    className: "cls-10",
    x1: 93.16,
    y1: 111.41,
    x2: 85.65,
    y2: 115.17
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    className: "cls-10",
    x1: 92.71,
    y1: 115.17,
    x2: 86.59,
    y2: 118.11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    className: "cls-3",
    d: "M123.69,67.83s-1.47,10.47,3.39,13.42l4.84,96.06,3.89,5.88v13.24a19.77,19.77,0,0,0,13.83-8c1.74-2.23-6.21-48.78-6.21-48.78l-3.91-21.52,7.59-4.87L142.2,80.69c-1-5-3.66-9.54-8.64-10.77l-2.46-.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    className: "cls-2",
    d: "M188.53,102.7l-1.45-2.63-6.51,3.57,3.84-4.47-2.16-2-3.86,4.18L171.77,105l-.28-.19,1.11-4.69-2.75-.24L168,106.74,156.53,113l6.15,11.21,11.19-6.15h0l1.33-.73L191,108.7l-1.52-2.78,2.15-1.18-1.58-2.88Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    className: "cls-10",
    x1: 189.92,
    y1: 101.94,
    x2: 181.31,
    y2: 106.67
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    className: "cls-10",
    x1: 190.78,
    y1: 105.12,
    x2: 182.85,
    y2: 109.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    className: "cls-2",
    d: "M171.72,105a5.67,5.67,0,0,1,3.88,2.48l2.4,4.36"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    className: "cls-10",
    x1: 167.97,
    y1: 106.74,
    x2: 166.43,
    y2: 112.98
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    className: "cls-3",
    d: "M133.56,69.91l1.67.39c5.14.92,6.26,7.74,7,10.38,1.45,5.33,7.89,31.14,7.89,31.14l9.28-3.11,6.15,17.8a3.5,3.5,0,0,1-2.16,4.44h0L143,137.68l-10.17-56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    className: "cls-4",
    d: "M112.42,71.12V68.41s4.57.72,9.81-3.65L125.34,71s-2.21,4-8.74,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    className: "cls-4",
    d: "M112,71.12V68.41s-4.56.72-9.8-3.65L99.07,71s2.21,4,8.74,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    className: "cls-8",
    d: "M135.8,182.22s4.19,5,3.58,8.09a6.66,6.66,0,0,1-3.58,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    className: "cls-8",
    d: "M88,182.22s-4.18,5-3.57,8.09a6.67,6.67,0,0,0,3.57,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    className: "cls-7",
    d: "M65.86,92.51l1.89,4.33,12.37,1.22-1.69-4.85a2.48,2.48,0,0,0-2.12-1.67l-9.11-.87a1.33,1.33,0,0,0-1.44,1.2A1.39,1.39,0,0,0,65.86,92.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-8",
    cx: 72.33,
    cy: 94.18,
    r: 1.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    className: "cls-6",
    x1: 150.09,
    y1: 111.81,
    x2: 145.67,
    y2: 113.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    className: "cls-2",
    d: "M112.48,44.76l-2.59,7.6a1.63,1.63,0,0,0,1,2,1.54,1.54,0,0,0,.52.09h2.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    className: "cls-3",
    d: "M131.1,69.35s3.89,1.5,3.65,6.89-6.47,28.88-6.47,28.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    className: "cls-3",
    d: "M93.28,69.64s-4.18,1.21-3.94,6.6,6.47,28.88,6.47,28.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    className: "cls-3",
    d: "M100.87,66.32l-5.38,1.07s-3,.92-3,5V88.25h2V72s0-2,1.19-2.62l4.71-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    className: "cls-8",
    d: "M92.46,84.33h2v2.53h-2V84.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    className: "cls-3",
    d: "M123.32,66.32l5.39,1.07s3,.92,3,5V88.25h-2V72s0-2-1.19-2.62l-4.7-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    className: "cls-3",
    d: "M129.74,86.68s-4.33-.19-4.33,4.21V106.8h1.73V91.26a2.63,2.63,0,0,1,2.18-3,1.93,1.93,0,0,1,.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    className: "cls-3",
    d: "M131.73,86.68s4.33-.19,4.33,4.21V106.8h-1.73V91.26a2.64,2.64,0,0,0-2.18-3,2,2,0,0,0-.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    className: "cls-7",
    d: "M133.12,103.62v3.17h-1v4.82h3a2.13,2.13,0,0,0,2.14-2.13h0v-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    className: "cls-7",
    d: "M128.55,103.62v3.17h1v4.82h-3a2.13,2.13,0,0,1-2.14-2.13h0v-5.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    className: "cls-7",
    cx: 93.27,
    cy: 90.73,
    r: 4.05
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "cls-7",
    cx: 93.27,
    cy: 90.73,
    r: 2.48
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.084f82618c073e361fa258dc111ff7c1.svg";
export { ForwardRef as ReactComponent };